/**
 * Current release version for cart storage compatibility
 * Increment when making breaking changes to cart data structure
 */
export const CART_VERSION = 0

export type ShippingCostConfigType = {
  channel: string
  region: string
  shippingCost: number
  freeShippingThreshold: number
}

export const SHIPPING_GLOBAL_FALLBACK_CONFIG: ShippingCostConfigType = {
  channel: "*",
  region: "*",
  shippingCost: 0,
  freeShippingThreshold: 0,
}

export const SHIPPING_COSTS_CONFIG: ShippingCostConfigType[] = [
  // Most specific matches first (channel + region)
  {
    channel: "store",
    region: "us",
    shippingCost: 795,
    freeShippingThreshold: 11900,
  },
  {
    channel: "store",
    region: "ca",
    shippingCost: 995,
    freeShippingThreshold: 15900,
  },
  {
    channel: "store",
    region: "ch",
    shippingCost: 795,
    freeShippingThreshold: 13100,
  },
  {
    channel: "store",
    region: "gb",
    shippingCost: 795,
    freeShippingThreshold: 9900,
  },
  {
    channel: "store",
    region: "au",
    shippingCost: 1195,
    freeShippingThreshold: 15500,
  },
  {
    channel: "store",
    region: "eu",
    shippingCost: 795,
    freeShippingThreshold: 13100,
  },
  {
    channel: "store",
    region: "nz",
    shippingCost: 1195,
    freeShippingThreshold: 15500,
  },
  // Channel wildcards (channel + *)
  {
    channel: "store",
    region: "*",
    shippingCost: 999,
    freeShippingThreshold: 7500,
  },
  {
    channel: "*",
    region: "us",
    shippingCost: 0,
    freeShippingThreshold: 0,
  },
  // Global fallback - keep this last
  SHIPPING_GLOBAL_FALLBACK_CONFIG,
]
